import axios from "axios";
import { baseUrl } from "../../Config/baseUrl";

export const GetManageStore = async (req) => {
  try {
    const response = await axios.get(
      `${baseUrl}/blog/superadmin-manage-store-api/`,
      {
        params: req,
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const PostManageStore = async (req) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/superadmin-manage-store-api/`,
      req,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const ModifyPassword = async (req) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/superadmin-change-store-password-api/`,
      req,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};

export const StoreTab = async (req) => {
  try {
    const response = await axios.get(
      `${baseUrl}/blog/superadmin-store-tab-api/`,
      {
        params: req,
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};


export const PostStoreTab = async (req) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/superadmin-store-tab-api/`,
      req,
      {

        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};
export const PostAdminStore = async (reqbody) => {
  try {
    const response = await axios.post(
      `${baseUrl}/blog/superadmin-store-enable-disable-api/`,
      reqbody,
      {
        headers: {
          Authorization: `Token ${localStorage.getItem("token")}`,
        },
      }
    );
    return response;
  } catch (err) {
    throw new Error(err);
  }
};
